import Text from '@ingka/text'
import { space50 } from '@ingka/variables'
import { Flex } from '@mantine/core'
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { Conversion } from 'lib/types/coworkerData.types'

import { backgroundColourDefault } from 'styles/tokens/insikt.tokens'

interface ConversionGraphProps {
  data: Conversion
}

const ConversionGraph = ({ data }: ConversionGraphProps) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart width={500} height={300} data={data.conversionTrendWeek}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={'period'} />
        <YAxis unit={'%'} width={100} />
        <Tooltip
          content={({ active, payload, label }: any) => {
            if (active && payload && payload.length) {
              return (
                <Flex miw={200} bg={backgroundColourDefault} direction={'column'} p={space50}>
                  <Text headingSize="s">{label}</Text>
                  <Text>{`Avg. conversion: ${payload[0].value}%`}</Text>
                  <Text>{`Handled volume: ${payload[0].payload.visitors}`}</Text>
                </Flex>
              )
            }
          }}
        />

        <Area
          dataKey="conversionRate"
          name="Conversion rate value"
          fill={'#95E5BB'}
          stroke={'#95E5BB'}
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default ConversionGraph
